<div class="import-error" *ngIf="control?.errors?.['importInputFile']">
  <div class="import-error-content">
    <div class="import-error-content-group">
      <span class="import-error-content-text">{{ 'cart.import.errors.columnLabel' | translate }}</span>

      <div class="import-error-content-wrapper">
        <div class="import-error-content-input-wrapper">
          <cx-input-field
            [control]="eanControl"
            [label]="'EAN'"
            [invalid]="!!eanControl.errors?.['required']"
            [valid]="!eanControl.errors?.['required'] && !!eanControl.value"
          />
          <span>{{ 'cart.import.errors.column1Example' | translate }}</span>
        </div>

        <div class="import-error-content-input-wrapper">
          <cx-input-field
            [control]="quantityControl"
            [label]="'Quantidade'"
            [invalid]="!!quantityControl.errors?.['required']"
            [valid]="!quantityControl.errors?.['required'] && !!quantityControl.value"
          />
          <span>{{ 'cart.import.errors.column2Example' | translate }}</span>
        </div>
      </div>
    </div>

    <div class="import-error-content-group">
      <span class="import-error-content-text">{{ 'cart.import.errors.lineLabel' | translate }}</span>

      <div class="import-error-content-input-wrapper">
        <cx-input-field
          [control]="eanControl"
          [label]="'Linha inicial'"
          [invalid]="!!eanControl.errors?.['required']"
          [valid]="!eanControl.errors?.['required'] && !!eanControl.value"
        />
        <span>{{ 'cart.import.errors.lineExample' | translate }}</span>
      </div>
    </div>

    <cx-button class="w-100">{{ 'cart.import.errors.submit' | translate }}</cx-button>
  </div>

  <img class="import-error-img" src="assets/medias/images/cart/import-example.png" alt="" />
</div>
